import { readCookie } from "./client"
import { apiUrl } from "./url"

const LOGOUT_PATH = "/api/auth/logout/"

/**
 * Delete the auth cookies the backend no longer accepts.
 *
 * `access` and `refresh` are httpOnly (JWT_AUTH_HTTPONLY), so JavaScript cannot
 * delete them: only the backend can, through the logout endpoint. It unsets both
 * cookies before it tries to blacklist the refresh token, so the Set-Cookie
 * deletions are emitted even when the response ends up 401 for a stale or
 * missing refresh token. The status is therefore ignored on purpose.
 *
 * A raw fetch is used rather than `apiClient`: its 401 interceptor would fire a
 * token refresh and retry the logout, which is pointless here.
 */
export async function clearAuthCookies(): Promise<void> {
  if (typeof window === "undefined") return
  try {
    const csrf = readCookie("csrftoken")
    await fetch(apiUrl(LOGOUT_PATH), {
      method: "POST",
      credentials: "include",
      headers: csrf ? { "X-CSRFToken": csrf } : {},
    })
  } catch {
    // Best effort: cleanup must never block the login attempt.
  }
}
